module.exports = __webpack_public_path__ + "static/media/school-leader.a0d2ec7c.svg";